module.exports = __webpack_public_path__ + "static/img07-a5fdef208c6c59acaa91a800f89c1172.jpg";